import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Cross from "../icon/Cross";
class PaymentBanner extends Component {
  state = {
    userChoice: true,
  };
  bannerGuide = () => {
    const {
      user: { auth },
      bannerPlan,
    } = this.props;
    if (auth === "notSignIn") {
      this.props.dispatch({ type: "toggleUserField", condition: "signIn" });
      return;
    } else {
      this.props.dispatch({
        type: "togglePaymentField",
        isPaymentGuideActive: true,
        paymentGuideMinPlan: bannerPlan,
      });
    }
  };
  render() {
    const {
      state: { userChoice },
      props: {
        messages,
        user: { auth, plan },
        tour,
        bannerPlan,
        location: { pathname },
      },
      bannerGuide,
    } = this;
    if (auth === "") return "";
    const selector = { Free: 0, Creator: 1, Brand: 2, Agency: 3 };
    const bannerPath = pathname.split("/")[1];
    const isTourActive = tour[`is${bannerPath}TourActive`];
    const isActive =
      (auth === "notSignIn" || selector[bannerPlan] > selector[plan]) &&
      userChoice &&
      !isTourActive;
    return (
      <Wrap isActive={isActive}>
        <Container>
          <Content
            id={
              auth === "notSignIn"
                ? `guide_banner_login_${bannerPath}`
                : `guide_banner_upgrade_${bannerPath}`
            }
            onClick={() => bannerGuide()}
          >
            {messages.guide_banner}
            {auth === "notSignIn"
              ? messages.guide_banner_login
              : messages.guide_banner_upgrade}
          </Content>
          <Cancel onClick={() => this.setState({ userChoice: false })}>
            <Cross color={"#fff"} />
          </Cancel>
        </Container>
      </Wrap>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state.User,
    messages: state.Messages,
    payment: state.Payment,
    tour: state.Tour,
  };
};
export default withRouter(connect(mapStateToProps)(PaymentBanner));

const Wrap = styled.div`
  position: fixed;
  display: ${({ isActive }) => (isActive ? "flex" : "none")};
  top: 72px;
  left: 0;
  width: 100%;
  background-color: rgba(222, 6, 6, 0.3);
  z-index: 10001;
  pointer-events: none;
`;
const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 3px;
  pointer-events: auto;
  color: #fff;
`;
const Content = styled.div`
  text-decoration: underline;
  cursor: pointer;
`;
const Cancel = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  right: 0;
  height: 100%;
  padding: 0 9px;
  margin-right: 20px;
  border-radius: 100%;
  cursor: pointer;
  &:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
`;



// WEBPACK FOOTER //
// ./src/Payment/PaymentBanner.js